module.exports = __webpack_public_path__ + "media/images/cleaning/main_image1-8e278f8d62885155ab84ef4a8a610f45.jpg";